import { round } from "@notemeal/shared-ui";

export const roundFoodMacro = (value: number | null) => {
  return round(value || 0, 1);
};
